import { useQuery } from "@tanstack/react-query";
import { cdFetch } from "../api";
import { queryKeys } from "../queryKeys";



export const useScreenConfig = () => {
  const { data, isLoading , refetch } = useQuery({
    queryKey: [queryKeys.screenConfig],
    queryFn: () => getScreenConfig(),
  });
  const screenConfigData = data?.data?.data;
  return {screenConfigData,isLoading};
};

const getScreenConfig = () => {
  const res = cdFetch(`/getScreensConfig`);
  return res;
};

